import { isSportsVOD } from 'src/components/MetaButtons/WatchlistBtn/WatchlistHandler';
import {
  DeleteItemParams,
  Episode,
  Show,
  WatchListBucket
} from 'src/components/MetaButtons/WatchlistBtn/WatchlistTypes';
import { GQL_QUERIES } from 'src/utils/analytics/newrelic/ErrorTracker';

import SimpleStore from '../../store/SimpleStore';
import { HTTP_URL_PARAMS } from '../../utils/constants/HttpMethodsConstants';
import { WatchListInput } from '../GraphQL/Queries/types';
import {
  ADD_TO_WATCH_LIST,
  DELETE_FROM_WATCHLIST,
  WATCH_LIST
} from '../GraphQL/Queries/WatchlistQuery';
import { graphQlRequest } from '../GraphQL/RequestHandler';

export const addItemToWatchlist = async (
  requestObj: WatchListInput,
  headers: string[]
) => {
  try {
    const response = await graphQlRequest(
      ADD_TO_WATCH_LIST,
      { input: requestObj },
      GQL_QUERIES.ADD_TO_WATCH_LIST,
      headers
    );
    return response.addToWatchList;
  } catch (error) {
    console.error('Error while adding to watchlist: ', error);
  }
};

export const removeItemFromWatchlist = async (
  requestObj: DeleteItemParams,
  headers: string[]
) => {
  try {
    const response = await graphQlRequest(
      DELETE_FROM_WATCHLIST,
      requestObj,
      GQL_QUERIES.DELETE_FROM_WATCHLIST,
      headers
    );
    return response.deleteFromWatchList;
  } catch (error) {
    console.error('Error while removing item from watchlist: ', error);
  }
};

export const fetchWatchlistItems = async (headers: string[]) => {
  try {
    const displayLanguage = SimpleStore.get(HTTP_URL_PARAMS.DISPLAY_LANGUAGE);
    const countryCode = SimpleStore.get(HTTP_URL_PARAMS.COUNTRY_CODE);
    const data = await graphQlRequest(
      WATCH_LIST,
      { countryCode, displayLanguage },
      GQL_QUERIES.WATCH_LIST,
      headers
    );
    if (data && Object.keys(data).length) {
      const episodes: any = [];

      const watchList: any = {
        show: [episodes],
        movie: [],
        video: [],
        trailer: [],
        plex: [],
        sports: [],
        clip: []
      };

      data.watchList.forEach((obj: WatchListBucket) => {
        const objId = obj.id;
        const objContents = obj.contents;
        if (obj && objId && objContents) {
          watchList[objId] = objContents;
        }
      });

      if (watchList && watchList.show) {
        watchList.show.forEach((show: Show) => {
          if (show?.episodes?.length) {
            show.episodes.forEach((episode: Episode) => {
              /* Adding tvshow node for navigation */
              episode.tvShow = {
                id: show.id,
                originalTitle: show.originalTitle
              };
              if (
                isSportsVOD({
                  assetSubType: episode?.assetSubType,
                  assetType: episode?.assetType
                })
              ) {
                watchList.sports.push(episode);
              } else {
                episodes.push(episode);
              }
            });
          }
        });
      }
      const videos =
        [...watchList.video, ...watchList.trailer, ...watchList.clip] || [];

      return {
        videos,
        episodes: episodes,
        movies: watchList.movie,
        plex: watchList.plex,
        sports: watchList.sports,
        isWatchlistDataFetched: true
      };
    }
  } catch (error) {
    console.error('Error while fetching watchlist items: ', error);
  }
  return {
    videos: [],
    episodes: [],
    movies: [],
    plex: [],
    sports: [],
    isWatchlistDataFetched: false
  };
};
